export enum UpdateOperationType {
    MODE_OF_TRANSPORT,
    EXPEDITE,
    RESCHEDULE,
    REDIRECT,
    DELIVERY_ACCESS_ID,
    DELIVERY_INSTRUCTIONS
}

export class ReasonCodesConfig {

    static readonly SIS = new ReasonCodesConfig("SIS", "SIS", "Sufficient Inventory/Supply", [UpdateOperationType.MODE_OF_TRANSPORT]);
    static readonly LIN = new ReasonCodesConfig("LIN", "LIN", "Low inventory", [UpdateOperationType.MODE_OF_TRANSPORT]);
    static readonly UDP = new ReasonCodesConfig("UDP", "UDP", "Urgent Demand/Production deadline", [UpdateOperationType.MODE_OF_TRANSPORT]);
    static readonly SCO = new ReasonCodesConfig("SCO", "SCO", "Safety concerns", [UpdateOperationType.MODE_OF_TRANSPORT]);
    static readonly SBS = new ReasonCodesConfig("SBS", "SBS", "Shipper booking submission  error", [UpdateOperationType.MODE_OF_TRANSPORT]);
    static readonly STC = new ReasonCodesConfig("STC", "STC", "Staffing concern / Unmanned site", [UpdateOperationType.REDIRECT]);
    static readonly ISS = new ReasonCodesConfig("ISS", "ISS", "Insufficient storage space", [UpdateOperationType.REDIRECT, UpdateOperationType.RESCHEDULE]);
    static readonly SNR = new ReasonCodesConfig("SNR", "SNR", "Site not ready", [UpdateOperationType.REDIRECT]);
    static readonly SRR = new ReasonCodesConfig("SRR", "SRR", "Site not ready for receiving (new site)", [UpdateOperationType.RESCHEDULE]);
    static readonly PDS = new ReasonCodesConfig("PDS", "PDS", "Project delays", [UpdateOperationType.RESCHEDULE]);
    static readonly USL = new ReasonCodesConfig("USL", "USL", "Unmanned site / Staffing allocation / On leave", [UpdateOperationType.RESCHEDULE]);
    static readonly COD = new ReasonCodesConfig("COD", "COD", "Consolidated delivery - small quantity (prefer for shipment consolidation)", [UpdateOperationType.RESCHEDULE]);
    static readonly INI = new ReasonCodesConfig("INI", "INI", "Internal Issue (wrong order, need to return back to vendor, etc)", [UpdateOperationType.RESCHEDULE]);
    static readonly HWD = new ReasonCodesConfig("HWD", "HWD", "Holiday/ Weekend", [UpdateOperationType.RESCHEDULE]);
    static readonly SPI = new ReasonCodesConfig("SPI", "SPI", "Shipment pull in", [UpdateOperationType.RESCHEDULE]);
    static readonly OTH = new ReasonCodesConfig("OTH", "OTH", "Others (a free text of  100 characters)", [UpdateOperationType.MODE_OF_TRANSPORT, UpdateOperationType.RESCHEDULE]);
    static readonly MDL = new ReasonCodesConfig("MDL", "MDL", "Manufacturing Delays", [UpdateOperationType.EXPEDITE]);
    static readonly PER = new ReasonCodesConfig("PER", "PER", "Planning Error", [UpdateOperationType.EXPEDITE]);
    static readonly CIT = new ReasonCodesConfig("CIT", "CIT", "Customer Impact", [UpdateOperationType.EXPEDITE]);
    static readonly MPT = new ReasonCodesConfig("MPT", "MPT", "Meeting Project Timeline", [UpdateOperationType.EXPEDITE]);
    static readonly UDD = new ReasonCodesConfig("UDD", "UDD", "Unexpected Demand", [UpdateOperationType.EXPEDITE]);
    static readonly TIS = new ReasonCodesConfig("TIS", "TIS", "Transportation Issues", [UpdateOperationType.EXPEDITE]);
    static readonly CIS = new ReasonCodesConfig("CIS", "CIS", "Customs Issues", [UpdateOperationType.EXPEDITE]);
    static readonly DLC = new ReasonCodesConfig("DLC", "DLC", "Documentation/Licensing Concerns", [UpdateOperationType.EXPEDITE]);
    static readonly SMI = new ReasonCodesConfig("SMI", "SMI", "System Issue", [UpdateOperationType.EXPEDITE]);

    static readonly ALL_FIELDS: ReasonCodesConfig[] = [
        ReasonCodesConfig.SIS,
        ReasonCodesConfig.LIN,
        ReasonCodesConfig.UDP,
        ReasonCodesConfig.SCO,
        ReasonCodesConfig.SBS,
        ReasonCodesConfig.STC,
        ReasonCodesConfig.ISS,
        ReasonCodesConfig.SNR,
        ReasonCodesConfig.SRR,
        ReasonCodesConfig.PDS,
        ReasonCodesConfig.USL,
        ReasonCodesConfig.COD,
        ReasonCodesConfig.INI,
        ReasonCodesConfig.HWD,
        ReasonCodesConfig.SPI,
        ReasonCodesConfig.OTH,
        ReasonCodesConfig.MDL,
        ReasonCodesConfig.PER,
        ReasonCodesConfig.CIT,
        ReasonCodesConfig.MPT,
        ReasonCodesConfig.UDD,
        ReasonCodesConfig.TIS,
        ReasonCodesConfig.CIS,
        ReasonCodesConfig.DLC,
        ReasonCodesConfig.SMI
    ]

    // private to restrict the creation other instances of this type
    private constructor(public readonly id: string, public readonly value: string, public readonly label: string, public readonly applicableOperations: (UpdateOperationType)[]) {}
}

export function getReasonCodes(types: Array<UpdateOperationType>) : Array<any> {
  const reasonCodes = new Array<any>();
  ReasonCodesConfig.ALL_FIELDS
    .filter(code => code.applicableOperations?.some(operation => types.includes(operation)))
    .forEach(code => reasonCodes.push({id: code.id, value: code.value, label: code.label}));
  return reasonCodes;
}